import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_SLUGS_BY_COLLECTION = gql`
query searchSlugsByCollection($searchString: String!, $collection: String!, $exact: Boolean) {
  searchSlugsByCollection(searchString: $searchString, collection: $collection, exact: $exact ) {
    isAuth
    slugNames
  }
}
`;

const searchSlugsByCollection = async (searchString, collection, exact = false) => {
  try {
    const result = await client
      .query({
        query: GET_SLUGS_BY_COLLECTION,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        variables: { searchString, collection, exact },
        fetchResults: true,
        pollInterva: 300000,
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });
    const {
      data: { searchSlugsByCollection: slugsByCollection },
    } = result;

    if (slugsByCollection) {
      return slugsByCollection;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: searchSlugsByCollection`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getPostsBySlugName Error: ${error}`);
    return null;
  }
};

export default searchSlugsByCollection;
